import {
  createFileRoute,
  useNavigate,
} from '@tanstack/react-router';
import React, {
  useEffect,
} from 'react';
import {
  useAuth,
} from 'react-oidc-context';

import {
  PendingProgress,
} from '#components/ui/progress/PendingProgress';
import BGD from '#resources/images/backgrounds/BGD.png?url';
import {
  sessionTokenValidator,
} from '#src/types/sessionToken';

export const Route = createFileRoute('/_app/auth/renew')({
  component: Renew,
  validateSearch: sessionTokenValidator,
});

export function Renew(): React.ReactNode {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    console.debug(`Renewing authentication token:`, auth);
    if (auth.isAuthenticated) {
      console.info(`User is authenticated`, auth.user);
      // auth.activeNavigator
      if (auth?.user?.url_state) {
        console.debug(
          `Redirecting to previous url state: ${auth?.user?.url_state}`,
        );
        navigate({
          to: auth?.user?.url_state,
        });
      } else if (auth?.user) {
        navigate({
          to: '/mydigitalworkers',
        });
      } else {
        navigate({
          to: '/',
        });
      }
    } else {
      console.warn(`User is not authenticated`);
    }
  }, [
    auth.isAuthenticated,
    navigate,
  ]);

  return (
    <div
      style={ {
        display: 'flex',
        textAlign: 'center',
        height: '100vh',
        width: '100vw',
        backgroundImage: `linear-gradient(245deg, rgb(17, 10, 34, 0) 0px, rgb(19, 11, 38, 0.98) 80%, rgb(32, 10, 43, 1) 100%), url("${BGD}")`,
      } }
    >
      <div
        style={ {
          height: '100vh',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(30px)',
          backgroundColor: 'rgb(255, 255, 255, 0.06)',
          position: 'absolute',
          zIndex: '1',
        } }
      >
        { auth.isLoading && (
          <PendingProgress />
        ) }
        { auth.error && !auth.isLoading && (
          <>
            <p>{ auth.error.message }</p>
          </>
        ) }
      </div>
    </div>
  );
}
